import { SIZE_50 } from '@/lib/gridElements/size';

import { MediaViewerKpiLoader } from '@/components/base/Kpi/KpiLoader';

import { totalReactionsConfig } from './../totalReactions';

export const mediaViewerReactionsConfig = {
    ...totalReactionsConfig,
    size: SIZE_50,
    name: 'kpi.linkedin.mediaviewer.reactions',
    tooltip: null,
    loader: MediaViewerKpiLoader
};
